<script>
  import { onMount } from "svelte";
  import { navigate } from "svelte-navigator";
  import { birthData } from "../stores/birthData.js";
  import { astroData } from "../stores/astroData.js";
  const apiUrl = "https://astro.astrosofica.nl/php/";

  // Use the $ sign to create reactive variables
  $: longitude = $birthData.longitude;
  $: latitude = $birthData.latitude;
  $: utcTime = $birthData.utcTime;
  $: utcDateStr = $birthData.utcDateStr;

  function navigateToNextPage() {
    // Navigate to new page with updated variables
    navigate("/horoscope");
  }

  async function getHouses(utcDateStr, utcTime, longitude, latitude) {
    const response = await fetch(`${apiUrl}houses.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        utcDate: utcDateStr,
        utcTime: utcTime,
        longitude: longitude,
        latitude: latitude,
      }),
    });
    const data = await response.json();
    return data.huizen;
  }

  async function getPlaneten(utcDateStr, utcTime) {
    const response = await fetch(`${apiUrl}planets.php`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ date: utcDateStr, utc: utcTime }),
    });
    const data = await response.json();
    return data.planeten;
  }

  // Use let instead of const for the planeten and huizen arrays since their contents change
  let planeten = [];
  let huizen = [];

  async function loadData() {
    if (
      utcDateStr &&
      utcTime &&
      longitude &&
      latitude &&
      !planeten.length &&
      !huizen.length
    ) {
      const [planetenData, huizenData] = await Promise.all([
        getPlaneten(utcDateStr, utcTime),
        getHouses(utcDateStr, utcTime, longitude, latitude),
      ]);
      planeten = planetenData;
      huizen = huizenData;
    }
  }

  // Use a ternary operator instead of an if-else block to simplify the isLoading/hasData check
  //$: isLoading = planeten.length === 0 && huizen.length === 0;
  $: hasData = planeten.length > 0 || huizen.length > 0;

  onMount(async () => {
    await loadData();
  });

  // if hasData is true run the planetInHouse function
  $: if (hasData) {
    astroData.update((data) => {
      data.planets = planeten;
      data.houses = huizen;
      return data;
    });
    navigateToNextPage();
  }
</script>

<h1>Calculating</h1>
